function TimelineConflict(layer, eventA, eventB, startTime, endTime){
    this.layer = layer;
    this.eventA = layer.getEventById(eventA);
    this.eventB = layer.getEventById(eventB);
    this.startTime = startTime;
    this.endTime = endTime;

    this.elem = UI.div('timelineConflict',null,null,{
        'click':this.click.bind(this)
    });
}

TimelineConflict.prototype = {
    click: function(ev){
        //ev = ev||window.event;
        // show conflict options modal window

    },
    draw: function(){
        // position the element on the layer
        var tl = this.layer.activeView?.timeline || globalTimeline;
        var left = tl.timeToOffset(this.startTime);
        var width = tl.timeToOffset(this.endTime) - left;
        this.elem.style.left = left + 'px';
        this.elem.style.width = width + 'px';
    },
    getElem: function(){
        return this.elem;
    }
};